export default __webpack_public_path__ + "src/assets/plista_logo.png";